(() => {
  const escapeSelector = (value) => {
    if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
      return CSS.escape(value);
    }
    return String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  };

  const getCollectionSearchUrl = (sidebar) => {
    if (!sidebar) return "";

    const handle = (
      sidebar.getAttribute("data-xcloud-collection-handle") || ""
    ).trim();
    if (!handle) return "";

    const root = window.Shopify?.routes?.root || "/";
    const normalizedRoot = root.endsWith("/") ? root : `${root}/`;
    return `${normalizedRoot}a/search/${encodeURIComponent(handle)}`;
  };

  const handleize = (str) => {
    return (str || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  const collectSidebarQuery = (sidebar) => {
    const params = new URLSearchParams();
    if (!sidebar) return params;

    const checkedBoxes = sidebar.querySelectorAll(
      '.cloud-search-filter-value input[type="checkbox"]:checked',
    );

    checkedBoxes.forEach((checkbox) => {
      const filterValueEl = checkbox.closest(".cloud-search-filter-value");
      const filterEl = checkbox.closest(".cloud-search-filter");
      if (!filterValueEl || !filterEl) return;

      // Prefer explicit data-filter-name, fall back to handleized label.
      const dataFilterName = (filterEl.getAttribute("data-filter-name") || "")
        .trim()
        .toLowerCase();
      const filterLabel = (
        filterEl.querySelector(".cloud-search-filter__name span:last-child")
          ?.textContent || ""
      ).trim();
      const filterName = dataFilterName || handleize(filterLabel);
      if (
        !filterName ||
        filterName === "collection" ||
        dataFilterName === "collection"
      )
        return;

      const value =
        filterValueEl.getAttribute("data-filter-value") ||
        filterValueEl
          .querySelector(".cloud-search-filter-value__name")
          ?.textContent?.trim() ||
        "";

      if (!value) return;
      params.append(`filter_${filterName}`, value);
    });

    return params;
  };

  const forceSecondSelectOpacity = (sectionRoot) => {
    if (!sectionRoot) return;

    const sidebar = sectionRoot.querySelector("#cloud_search_filters_sidebar");
    if (!sidebar) return;

    const selects = Array.from(
      sidebar.querySelectorAll(".cloud-search-theme-select"),
    );
    if (selects.length < 2) return;

    const hasAnySelection = selects.some((select) => select.value !== "");
    if (hasAnySelection) return;

    selects.forEach((select, index) => {
      const group = select.closest(".filters-sidebar-filter");
      const opacity = index === 1 ? "1" : "0.5";

      select.style.opacity = opacity;
      if (group) {
        group.style.opacity = opacity;
      }
    });
  };

  const bindCollectionRedirect = () => {
    if (window.__xcloudCollectionRedirectBound) return;
    window.__xcloudCollectionRedirectBound = true;

    // Force slideshow page apply buttons to navigate to /a/search/{handle} and bypass /a/search/all.
    document.addEventListener(
      "click",
      (event) => {
        const applyButton = event.target.closest(
          ".filters-sidebar-apply, .cloud-search-filters-apply",
        );
        if (!applyButton) return;

        const sidebar = applyButton.closest("#cloud_search_filters_sidebar");
        if (!sidebar) return;

        const queryParams = collectSidebarQuery(sidebar);
        const query = queryParams.toString();
        const action = getCollectionSearchUrl(sidebar);
        if (!action) return;

        const redirectUrl = query ? `${action}?${query}` : action;

        event.preventDefault();
        event.stopPropagation();

        window.location.assign(redirectUrl);
      },
      true,
    );
  };

  const applyPrefilterForSection = (sectionRoot, expectedHandle) => {
    if (!sectionRoot || !expectedHandle) return true;

    const sidebar = sectionRoot.querySelector("#cloud_search_filters_sidebar");
    if (!sidebar) return false;

    const filters = Array.from(
      sidebar.querySelectorAll(".cloud-search-filter"),
    );
    const collectionFilter = filters.find((filter) => {
      const dataName = (filter.getAttribute("data-filter-name") || "")
        .trim()
        .toLowerCase();
      if (dataName === "collection") return true;

      const labelName = (
        filter.querySelector(".cloud-search-filter__name span:last-child")
          ?.textContent || ""
      )
        .trim()
        .toLowerCase();
      return labelName === "collection";
    });

    if (!collectionFilter) return false;

    const targetValue = collectionFilter.querySelector(
      `.cloud-search-filter-value[data-filter-value="${escapeSelector(expectedHandle)}"]`,
    );

    if (!targetValue) return true;

    const checkbox = targetValue.querySelector('input[type="checkbox"]');
    if (!checkbox) return true;

    if (!checkbox.checked) {
      targetValue.click();
    }

    sectionRoot.querySelector(".cloud-search-filters-apply")?.click();
    return true;
  };

  const initSectionPrefilter = (sidebar) => {
    const sectionRoot = sidebar.closest('[id^="shopify-section-"]');
    const expectedHandle = (
      sidebar.getAttribute("data-xcloud-collection-handle") || ""
    )
      .trim()
      .toLowerCase();

    if (!sectionRoot || !expectedHandle) return;

    let applied = false;

    const run = () => {
      if (applied) return true;
      if (applyPrefilterForSection(sectionRoot, expectedHandle)) {
        applied = true;
        return true;
      }
      return false;
    };

    const observer = new MutationObserver(() => {
      forceSecondSelectOpacity(sectionRoot);

      if (run()) {
        observer.disconnect();
      }
    });

    observer.observe(sectionRoot, { childList: true, subtree: true });

    if (run()) {
      observer.disconnect();
    }

    requestAnimationFrame(() => forceSecondSelectOpacity(sectionRoot));
    setTimeout(() => forceSecondSelectOpacity(sectionRoot), 120);

    setTimeout(() => observer.disconnect(), 10000);
  };

  const init = () => {
    document
      .querySelectorAll(
        "#cloud_search_filters_sidebar[data-xcloud-collection-handle]",
      )
      .forEach((sidebar) => initSectionPrefilter(sidebar));

    bindCollectionRedirect();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      init();
    }
  });
})();
